import React from 'react';

import { EuiProgress } from '../../../../src/components';

export default () => (
  <div>
    <EuiProgress size="xs" color="accent" />
  </div>
);
